// BL598 Phase 2 — `grid create <noun>` (kubectl-noun pattern).

import { Command } from 'commander';
import { createGridCommand } from './grid.js';

export const createCommand = new Command('create')
  .description('Create a grid')
  .addCommand(createGridCommand);
